import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moxie-generic-card-summary',
  templateUrl: './moxie-generic-card-summary.component.html',
  styleUrls: ['./moxie-generic-card-summary.component.css']
})
export class MoxieGenericCardSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
